import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import PaginationLocal from "../../components/PaginationLocal";
import TableStyles from "../../styles/components/TableStyles";
import HelpStyles from "../../styles/pages/Help/HelpStyles";
import { useHelp } from "../../context/HelpContext";
import { Document } from "../../context/interfaces/IHelpContext";
import { UserRole } from "../../model/Enums/UserRoleEnum";
import GenericUtils from "../../utils/GenericUtils";
import HelpService from "../../service/Docente/HelpService";
import {
    IBlobStorage,
    getAccountFromBlobUrl,
    getBlobStorageString,
    getSasTokenFromBlobUrl,
} from "../../utils/BlobDownload";
import ModalHelp from "../../components/NavbarHelp/ModalHelp";

const { StyledTableTitle, StyledButtonList } = HelpStyles;

const CONTAINER_NAME = "filehelp";

const HelpList = () => {
    const [blobContent, setBlobContent] = useState<Blob | undefined>();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [filteredData, setFilteredData] = useState<Document[]>([]);

    const { instance } = useMsal();
    const { documents } = useHelp();
    const typeFile = "DOWNLOAD";

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const getCreatedHelp = async (
        userRole: UserRole | null
    ): Promise<Document | null> => {
        const response = await HelpService.getImportedDocumentByFeatureId(
            instance,
            userRole
        );

        if (
            GenericUtils.isSuccessStatus(response) &&
            response.data &&
            response.data?.id
        ) {
            return response.data;
        }

        return null;
    };

    const getDownloadUrl = async (featureId: UserRole) => {
        const createdHelp = await getCreatedHelp(featureId);

        if (!createdHelp) return;

        const response = await HelpService.getFileUrl(
            instance,
            featureId,
            createdHelp.fileName,
            typeFile
        );

        if (
            GenericUtils.isSuccessStatus(response) &&
            response.data &&
            response.data?.link.length
        ) {
            const url = response.data?.link;

            const blobParams: IBlobStorage = {
                account: getAccountFromBlobUrl(url),
                sas: getSasTokenFromBlobUrl(url),
                containerName: CONTAINER_NAME,
                blobName: createdHelp.fileName,
            };
            const newBlobContent = await getBlobStorageString({
                ...blobParams,
            });
            setBlobContent(newBlobContent);
            handleOpenModal();
        }
    };

    const convertFileName = (fileName: string): string => {
        if (!fileName.length) return "";

        const parts = fileName.split("_");
        return parts.slice(1).join("_");
    };

    useEffect(() => {
        setFilteredData(documents);
    }, [documents]);

    const bodyOfTable =
        filteredData &&
        filteredData.map((item: Document) => {
            return (
                <tr key={item.id}>
                    <td>{item.funcionalidade.nome}</td>
                    <td>
                        <StyledButtonList
                            onClick={() =>
                                getDownloadUrl(item.funcionalidadeId)
                            }
                        >
                            {convertFileName(item.fileName)}
                        </StyledButtonList>
                    </td>
                </tr>
            );
        });

    return (
        <>
            <StyledTableTitle>Lista de Funcionalidades</StyledTableTitle>
            <TableStyles.TablePrimary
                bordered
                striped
                responsive
                style={{ marginBottom: 0 }}
            >
                <thead>
                    <tr>
                        <th>Nome da Tela</th>
                        <th>Nome do Arquivo</th>
                    </tr>
                </thead>
                <tbody>
                    {documents && documents.length === 0 ? (
                        <tr>
                            <td colSpan={2}>Nenhuma informação disponível.</td>
                        </tr>
                    ) : (
                        bodyOfTable
                    )}
                </tbody>
            </TableStyles.TablePrimary>
            <PaginationLocal
                items={documents || []}
                itemsPage={10}
                onPaginate={(data) => setFilteredData(data)}
                hidePagination={false}
            />
            {showModal && blobContent && (
                <ModalHelp
                    open={showModal}
                    onClose={handleCloseModal}
                    pdfContent={blobContent}
                />
            )}
        </>
    );
};

export default HelpList;
